import { addEventEmitterListenerPair } from '../../Common/events/utils';
import { TestPreviewProps } from '../../TestPrep/screens';

export const COURSE_UNIT_UPDATE = 'courseUnitUpdate';

export const [emitUpdateCourseUnitEvent, addUpdateCourseUnitEventListener] =
  addEventEmitterListenerPair<TestPreviewProps>(COURSE_UNIT_UPDATE);
